import { WelcomeAnimation, WelcomeContent, WelcomeModal } from '@atlassian/twc-xflow-modal';
import {
	type MessageInstanceClickedParams,
	useMessageInstanceEvent,
} from '@post-office/message-instance-event-frontend-client';
import { useMessageEvent } from '@post-office/message-lifecycle';
import { useCallback, useMemo, useState } from 'react';

import { createRender } from './types';

export const render = createRender(({ onDismissed, userName, links = [], messageInstanceId }) => {
	const { messageInstanceClicked } = useMessageInstanceEvent();
	const { messageClicked, messageDismissed } = useMessageEvent();

	const url = useMemo(
		() => links?.find?.((link) => link.key === 'jira-sample-space:url')?.href,
		[links],
	);

	const handleDismissed = useCallback(() => {
		const clickEvent: MessageInstanceClickedParams = {
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: 'welcome-modal-twc-dismiss',
				clickedElement: 'button',
				buttonType: 'primary',
			},
			action: {
				actionType: 'dismiss',
			},
			additionalMetadataFromFrontend: {},
		};
		void messageClicked();
		void messageInstanceClicked(clickEvent);
		void messageDismissed();
		onDismissed(messageInstanceId);
	}, [onDismissed, messageInstanceId, messageClicked, messageInstanceClicked, messageDismissed]);

	const handleCTAClicked = useCallback(() => {
		const clickEvent: MessageInstanceClickedParams = {
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: 'welcome-modal-twc-cta',
				clickedElement: 'button',
				buttonType: 'primary',
			},
			action: {
				actionType: 'open',
			},
			additionalMetadataFromFrontend: {},
		};
		void messageClicked();
		void messageInstanceClicked(clickEvent);
		onDismissed(messageInstanceId);
	}, [messageClicked, messageInstanceClicked, onDismissed, messageInstanceId]);

	const [isAnimationComplete, setIsAnimationComplete] = useState(false);

	const handleAnimationComplete = () => {
		setIsAnimationComplete(true);
	};

	if (!url) {
		return null;
	}

	return (
		<WelcomeModal
			isOpen
			onClose={handleDismissed}
			testId="twc-welcome-modal"
			Animation={<WelcomeAnimation onComplete={handleAnimationComplete} />}
			Content={
				<WelcomeContent
					onGetStarted={handleCTAClicked}
					onClose={handleDismissed}
					userName={userName}
					testId={'twc-welcome-modal-content'}
					isVisible={isAnimationComplete}
					href={url}
					type="link"
				/>
			}
		/>
	);
});

export default render;
